import React from 'react';
import DnDRow from 'components/lib/tables/dnd/DnDRow';
import DnDBucketRows from 'components/lib/tables/dnd/DnDBucketRows';
import DnDBucketFooter from 'components/lib/tables/dnd/DnDBucketFooter';
import ColorTag from 'components/lib/icons/ColorTag';
import 'utils/utils';
import styles from 'styles/components/lib/tables/dnd/dndRow.css';


export default class DnDRowContainer extends React.Component {
  constructor(props) {
    super(props);
    let isTemplate = props.index === undefined;
    let isEditing = props.selectedParent &&
      props.selectedParent.key === props.id;
    this.state = {
      bucket: {
        name: props.row.name || '',
        color: props.row.color || ''},
      hasError: false,
      isEmtpyName: false,
      isExpanded: this.props.isNewBucket || isEditing ? true : false, //isTemplate || isEditing,
      isEditing: this.props.isNewBucket ? true : isTemplate || isEditing,
      showHolder: false,
      size: { width: 0, height: 0 }
    };
    this.toggleRow = this.toggleRow.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
  }

  componentDidMount() {
    let ele = this.refs[`id${this.props.id}`];
    ele.addEventListener('transitionend', (e) => {
      this.getSize(ele);
    });
    this.getSize(ele);
    window.addEventListener('closeEdit', (e) => {
      if(this.state.isEditing && this.state.isExpanded && !this.props.isNewBucket) {
        this.resetState();
      } else if (this.props.isNewBucket) {
        this.props.onCancel();
      }
    })
  }

  componentWillReceiveProps(nProps) {
    if ( nProps.row && this.props.row &&
        !this.props.row.hasOwnProperty('children') &&
        nProps.row.hasOwnProperty('children') ) {
        console.log('nProps',  nProps.row);
        // row merged into bucket
         this.setNewBucket(nProps.row);
    }
    if (nProps.isNewBucket) {
      this.setState({ isExpanded: true, isEditing: true });
    } else if (!this.state.isExpanded && (nProps.selectedParent.id === nProps.id) ) {
      // if bucket is being edited -> keep it open
      this.setState({ isExpanded: true, isEditing: true });
    }
    if (nProps.errorBucketKey === this.props.id) {
      this.setState({
        isEditing: true,
        isExpanded: true
      })
    } else if (this.props.errorBucketKey && nProps.errorBucketKey === null) {
      this.setState({
        isEditing: false,
        isExpanded: false
      })
    }
  }

  componentWillUnmount() {
    let ele = this.refs[`id${this.props.id}`];
    ele.removeEventListener('transitionend', (e) => {
      this.getSize(ele);
    });
    window.addEventListener('closeEdit', (e) => {
      if(this.state.isEditing && this.state.isExpanded && !this.props.isNewBucket) {
        this.resetState();
      } else if (this.props.isNewBucket) {
        this.props.onCancel();
      }
    })
  }

  getSize = (ele) => {
    let rect = ele.getBoundingClientRect();
    this.setState({size: {width: rect.width, height: rect.height} });
  }

  handleEmptyName = (value) => {
    if (value === '') {
      this.setState({ isEmptyName: true })
    } else {
      this.setState({ isEmptyName: false })
    }
  }

  handleEditDetails = (accessor, value ) => {
    let { bucket } = this.state;
    let hasError = !(bucket.name || accessor === 'name');
    let editedBucket = {};
    if (accessor === 'color') value = value.substring(1);
    if ( accessor && value &&
      bucket[accessor] !== value) {
        editedBucket = { ...bucket, [accessor]: value }
        this.setState({
          bucket: editedBucket,
          hasError: hasError
        }, () => {
          if (this.props.index === undefined) {
            if(this.props.isNewBucket)this.props.onEditNewBucket(editedBucket);
            else {
              if (this.props.packages) this.props.onEditBucket(editedBucket, true)
              else this.props.onEditBucket(editedBucket);
            }
          }
        });
    } else if ( hasError !== this.state.hasError) {
      this.setState({ hasError });
    }
  }

  handleDeleteChild = (e, deletedChild) => {
    if (this.props.isNewBucket) this.props.onDeleteChild(e, deletedChild, true);
    else this.props.onDeleteChild(e, deletedChild);
    this.setState({ isExpanded: true, isEditing: true })
  }

  resetState = () => {
    this.props.onSetParent(null);
    this.props.onCloseEdit();
    this.setState({
      bucket: {
        name: this.props.row.name,
        color: this.props.row.color },
      hasError: false,
      isEditing: false,
      isExpanded: !this.state.isExpanded,
      isEmptyName: false
    }, () => {
      // console.log(this.state);
    });
  }

  setNewBucket = (bucket) => {
    this.setState({ ...this.state,
      bucket: { name: bucket.name || '', color: bucket.color },
      hasError: false,
      isExpanded:  true,
      isEditing: true
    });
  }

  toggleRow() { // expands / close rows. on close: exits edit mode + discard changes
    let isExpanded = !this.state.isExpanded;
    if (!this.state.bucket.name) {
      this.setState({ hasError: true });
    }
    else {
      if (!isExpanded && this.state.isEditing) { // on close
        this.props.onCloseEdit();
        this.resetState();
      } else {
        this.setState({ isExpanded });
      }
    }
  }

  toggleEdit(e, printHover) {//  console.log("TOGGLE EDIT");// exits/enter edit mode. onclose -> saves details
    e.stopPropagation();
    let isEditing = printHover ? false : !this.state.isEditing;
    let isExpanded = isEditing ? true : false;
    if (!this.state.bucket.name) {
      this.setState({ hasError: true });
    } else if (printHover) {
      this.props.onSetParent();
      this.setState({ isEditing, isExpanded });
    } else {
      // this.props.onSetParent();
      if (isEditing) {
        this.props.onClearDraggedRows();
        this.props.onSetParent({ key: this.props.id, index: this.props.index});
      } else this.props.onEditBucket(this.state.bucket, this.props.id);
      this.setState({ isEditing, isExpanded });
    }
  }

  render() {
    let { buckets, columns, draggedRowsKeys, id, index, isDragged,
          isSelectedGroup, isUnactive, isNewBucket, row } = this.props;
    let { hasError, isExpanded, isEditing, bucket } = this.state;
    let hasChildren = row && row.hasOwnProperty('children');
    let height = 60;
    let pad = 10
    let maxHeight = height;
    let opacity = isUnactive ? '0.3' : '0.7';
    if (hasChildren) {
      if (Object.keys(row.children).length > 0) {
        maxHeight = (Object.keys(row.children).length * (height + pad + 40)) + 100;
      } else maxHeight = 125;

    }

    let wrapperStyle = {
       minHeight: `${height}px`,
        maxHeight: `${isExpanded ? `${maxHeight}px` : `${height}px`}`,
       paddingLeft: `${hasChildren ? '0px' : '0px'}`,
       opacity: `${(isUnactive || isDragged) && !hasChildren ? `${opacity}` : '1'}`};
    let disableDrag = isUnactive || hasChildren;


    if (bucket.color &&  bucket.color !== row.color) row.color = bucket.color;
    
    return (
      <div key={id} id={id}
        className={styles.dndRowContainer}
        draggable={!disableDrag}
        onDragOver={disableDrag ? undefined : this.props.onDragOver}
        onDrop={(this.props.isNewBucketCreation || this.props.isEditing)
          ? null : (e) => this.props.onDrop(e, { key: id, index: index }, hasChildren, isUnactive)}
        style={{ minHeight: `${height+pad}px`}}>
        <div className={isUnactive ? styles.shadowNoHover : styles.shadow}>
          <div ref={`id${this.props.id}`} className={styles.wrapper} style={wrapperStyle} >
            { hasChildren &&
              <ColorTag
                usedColors={this.props.bucketColors}
                color={bucket.color}
                isEditing={isEditing}
                isExpanded={isExpanded}
                onChange={this.handleEditDetails}
                size={this.state.size} />
            }
            <div style={{flexGrow: '1'}}>
              <DnDRow
                buckets={buckets || {}}
                clearError={this.props.clearError}
                columns={columns}
                errorMessage={this.props.errorMessage}
                hasChildren={hasChildren}
                hasError={hasError}
                handleEmptyName={this.handleEmptyName}
                id={id}
                index={index}
                isDragged={isDragged}
                isEditing={this.props.isNewBucket ? true : isEditing}
                isExpanded={isExpanded}
                isNewBucket={this.props.isNewBucket}
                isNewBucketCreation={this.props.isNewBucketCreation}
                isOtherBucketEditing={this.props.isEditing}
                isSelected={draggedRowsKeys.indexOf(id) > -1}
                isSelectedGroup={isSelectedGroup}
                isTouchDevice={this.props.isTouchDevice}
                isUnactive={isUnactive}
                name={bucket.name}
                onAddToBucket={this.props.onAddToBucket}
                onAddToNewBucket={this.props.onAddToNewBucket}
                onClickEdit={this.toggleEdit}
                onClickExpand={hasChildren && this.toggleRow}
                onClickName={this.toggleEdit}
                onDelete={(e) => this.props.onDelete(e, {id: id, index: index} )}
                onDragAdd={this.props.onDragAdd}
                onDragBucket={this.props.onDragBucket}
                onDragOver={this.props.onDragOver}
                onDragRemove={this.props.onDragRemove}
                onDragEnd={this.props.onDragEnd}
                onDragLeave={this.props.onDragLeave}
                onEditDetails={this.handleEditDetails}
                onNewNameChange={this.props.onNewNameChange}
                onSelect={this.props.onSelect}
                onTouchEnd={this.props.onTouchEnd}
                onTouchStart={this.props.onTouchStart}
                packages={this.props.packages}
                row={row}
                toggleRow={this.toggleRow} />
              { hasChildren && [
                <DnDBucketRows
                  key="bucketRows"
                  columns={columns}
                  draggedRowsKeys={draggedRowsKeys}
                  errorMessage={this.props.errorMessage}
                  id={id}
                  isEditing={this.state.isEditing}
                  isNewBucket={this.props.isNewBucket}
                  isNewBucketCreation={this.props.isNewBucketCreation}
                  isUnactive={isUnactive}
                  parent={{index: index, key: row.key}}
                  name={this.state.bucket.name}
                  rows={Object.values(row.children)}
                  onDeleteChild={this.handleDeleteChild}
                  onDragAdd={this.props.onDragAdd}
                  onDragOver={this.props.onDragOver}
                  onDragRemove={this.props.onDragRemove}
                  onDragEnd={this.props.onDragEnd}
                  onDragLeave={this.props.onDragLeave}
                  onTouchEnd={this.props.onTouchEnd}
                  onTouchStart={this.props.onTouchStart}
                  onSelect={this.props.onSelect}
                  packages={this.props.packages}
                  isTouchDevice={this.props.isTouchDevice} />,
                index !== undefined &&
                  <DnDBucketFooter key="rowFooter"
                    color={row.color}
                    errorMessage={this.props.errorMessage}
                    isEmpty={Object.keys(row.children).length === 0}
                    isEmptyName={this.state.isEmptyName}
                    isEditing={this.state.isEditing}
                    onCancel={this.resetState}
                    onClickEdit={this.toggleEdit}/> ]
              }
              { isNewBucket &&
                <DnDBucketFooter key="rowFooter"
                  isEditing={this.state.isEditing}
                  isNewBucket={this.props.isNewBucket}
                  name={this.props.name}
                  onNewNameChange={this.props.onNewNameChange}
                  onCancel={this.props.onCancel}
                  onSubmit={this.props.onSubmit} />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/*
const SpaceHolder = ({height, index, isActive, ...props}) => (
  <div
    onDragOver={props.onDragOver}
    onDrop={((e) => props.onDropMove(e, index))}
    style={{backgroundColor: '#FCFBE3', padding: `${isActive ? '5px' : '10px'} 7px`, transition: 'all 0.3s ease-in-out'}} onMouseOver={props.onHover} onMouseLeave={props.onHover}>
    <div
      style={ isActive ?
        {height: '50px', backgroundColor: '#eeeae5',border: '1px dotted #987b4f', borderRadius: '7px', transition: 'all 0.3s ease-in-out'}
        : {height: '0px', backgroundColor: 'transparent',border: '1px dotted transparent', borderRadius: '7px', transition: 'all 0.3s ease-in-out'}}/>
  </div>
);
*/



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDRowContainer.js